import { BadgeWithTip, type BadgeProps } from "@/components/Badge.tsx";
import { Trans } from "@lingui/react/macro";
import type { ManagedKubernetesService } from "@warrenio/api-spec/spec.oats.gen";
import type { ReactNode } from "react";
import { truncate } from "remeda";

type Status = "online" | "hibernated" | "hibernating" | "waking_up";

const statusLabels: Record<Status, ReactNode> = {
    online: <Trans>Online</Trans>,
    hibernated: <Trans>Hibernated</Trans>,
    hibernating: <Trans>Hibernating</Trans>,
    waking_up: <Trans>Waking up</Trans>,
};

const statusColors: Record<Status, BadgeProps["color"]> = {
    online: "success",
    hibernated: "default",
    hibernating: undefined,
    waking_up: "primary",
};

export function KubernetesStatusBadge({ item }: { item: ManagedKubernetesService }) {
    const { properties } = item || {};

    if (properties?.spec?.hibernation && properties?.status) {
        const lastOperation = truncate(properties?.status?.lastOperation?.description ?? "", 400);
        const progress = properties?.status?.lastOperation?.progress ?? 0;
        const lastPercentage = progress < 100 ? progress : 0;

        let status: Status = "online";
        if (properties.spec.hibernation.enabled && properties.status.hibernated) {
            status = "hibernated";
        }
        if (properties.spec.hibernation.enabled && !properties.status.hibernated) {
            status = "hibernating";
        }
        if (!properties.spec.hibernation.enabled && properties.status.hibernated) {
            status = "waking_up";
        }

        return (
            <BadgeWithTip description={lastOperation} color={statusColors[status]}>
                {statusLabels[status]}{" "}
                {lastPercentage > 0 ? <>({properties?.status?.lastOperation?.progress}%)</> : null}
            </BadgeWithTip>
        );
    } else {
        return null;
    }
}
